var path = 'areas/shared/views/alerts.html';
var html = "<div> <div ng-repeat=\"alert in list\"> <div class=alert ng-class=\"{ 'alert-danger': alert.Severity == 'Danger' }\"> {{ alert.Message }} </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/alerts.html
// module id = 7071355051164336
// module chunks = 1